import type { AuthUser } from "@repo/shared";

const ACCESS_TOKEN_KEY = "sm_access_token";

// localStorage so the session survives tab/window closes and page refreshes.
export function getAccessToken(): string | null {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
}

export function setAccessToken(token: string): void {
  localStorage.setItem(ACCESS_TOKEN_KEY, token);
}

export function clearAccessToken(): void {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
}

export function parseJwtPayload(token: string): AuthUser | null {
  try {
    const parts = token.split(".");
    if (parts.length !== 3) return null;
    const payload = JSON.parse(atob(parts[1] ?? "")) as Record<string, unknown>;
    return {
      id: payload["sub"] as string,
      email: payload["email"] as string,
      name: payload["name"] as string,
      role: payload["role"] as AuthUser["role"],
    };
  } catch {
    return null;
  }
}

export function isTokenExpired(token: string): boolean {
  try {
    const parts = token.split(".");
    const payload = JSON.parse(atob(parts[1] ?? "")) as { exp: number };
    return Date.now() / 1000 > payload.exp;
  } catch {
    return true;
  }
}
